import { get, post, del } from '@elementary/common-ui/utils/http';
import {
  CreateTokenRequest,
  CreateTokenResponse,
  GetTokensResponse,
} from '../../shared/types';

export const getAccountTokens = async (): Promise<GetTokensResponse> =>
  get(`${import.meta.env.VITE_API_BASE_URL}/account/settings/account-tokens`);

export const createAccountToken = async (
  data: CreateTokenRequest,
): Promise<CreateTokenResponse> =>
  post(
    `${import.meta.env.VITE_API_BASE_URL}/account/settings/account-tokens`,
    data,
  );

export const deleteAccountToken = async (tokenId: string): Promise<void> =>
  del(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/account/settings/account-tokens/${tokenId}`,
  );
